import styled, { css } from "styled-components";
import CloseWhite from "images/common-function/close-white.png";

export const Wrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 700px;
  max-width: 100%;
  height: calc(100% - 140px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.8);
`;

export const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #3498db;
  position: relative;
  padding: 0 20px;
  > h2 {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    max-width: 610px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    background: url(${CloseWhite}) no-repeat center center;
    background-size: 17px;
  }
`;

export const ContentWrap = styled.div`
  padding: 46px 30px 20px;
  font-size: 16px !important;
  height: calc(100% - 50px - 90px);
  box-sizing: border-box;
  overflow-y: auto;
`;

export const Content = styled.div`
  min-height: 469px;
  img {
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin: 0 auto;
  }
  iframe {
    height: 100%;
    width: 100%;
  }
`;

export const UserWrap = styled.div`
  border-bottom: 1px solid #f5f5f5;
  padding: 14px 20px;
  height: 90px;
  box-sizing: border-box;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  > img {
    width: 23px;
    height: 23px;
    margin-right: 6px;
    border-radius: 50%;
  }
  > em {
    font-size: 12px;
    font-weight: bold;
  }
  > span {
    display: flex;
    align-items: flex-start;
    color: #ccc;
    :before {
      content: "·";
      display: block;
      margin: 0 7px;
    }
  }
`;

export const Buttons = styled.div`
  button {
    border: 1px solid #e5e5e5;
    padding: 0 13px;
    font-size: 11px;
    height: 26px;
    margin-right: 6px;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 30px;
  button {
    height: 35px;
    padding: 0 15px;
    font-size: 12px;
    border: 1px solid;
    &.good {
      color: #ed2026;
      border-color: #ed2026;
      &.active {
        color: #fff;
        background-color: #ed2026;
      }
    }
    &.report {
      border-color: #ebeef3;
    }
    &.modify {
      margin-right: 5px;
    }
  }
`;
